import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, Box, CssBaseline } from "@mui/material";

import { mainLayoutStyles, showNotification } from "../../../../../constants";
import {
  AdminUserDetailsBottomCardSection,
  AdminUserDetailsTopCardSection,
} from "../../components/components";
import DetailsPageHeader from "../../../../../common/DetailsPageHeader";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import { updateAdmin } from "../../../../../modules/Admins/hooks/AdminsHook";
import { useAdminsContext } from "../../../../../providers/OrganizationAdmin/AdminsProvider";
import { Toast } from "../../../../../common/alert";
import { uploadAdminImageToStorage } from "../../hooks/GAAdminHooks";
import ImagePreviewModal from "../../../../../common/ImagePreviewModal";
import { useAuth } from "../../../../../hooks";
import {
  getAuth,
  updatePassword as updateFirebasePassword,
  updatePassword,
} from "firebase/auth";

const AdminUserDetailsContainer = () => {
  const { currentUser } = useAuth();
  const { handleGetGAAdmins, setLoading, loading } = useAdminsContext();
  const location = useLocation();
  const navigate = useNavigate();

  const [adminUserDetails, setAdminUserDetails] = useState(
    location?.state?.adminUserDetails || {}
  );
  const [editEnabled, setEditEnabled] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };
  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
  };

  useEffect(() => {
    // Check if we have no data - redirect to parent page
    if (!location?.state?.adminUserDetails?.id) {
      navigate('/admin-users', { replace: true });
      return;
    }

    setAdminUserDetails(location.state.adminUserDetails);
  }, [location.state, navigate]);

  // Don't render anything if we don't have valid admin user data
  if (!adminUserDetails?.id) {
    return null;
  }

  const handleUpdateAdmin = async () => {
    try {
      setLoading(true);
      let temp = {
        firstName: adminUserDetails.firstName ? adminUserDetails.firstName : "",
        lastName: adminUserDetails.lastName ? adminUserDetails.lastName : "",
        userName: adminUserDetails.userName ? adminUserDetails.userName : "",
        status: adminUserDetails.status ? adminUserDetails.status : "",
        role: adminUserDetails.role ? adminUserDetails.role : "",
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      if (uploadImage != null) {
        let photoUrl = await uploadAdminImageToStorage(
          uploadImage?.raw,
          adminUserDetails.id
        );
        temp.photoUrl = photoUrl;
        temp.originalPhotoName = uploadImage?.raw?.name;
      }
      let responseTemp = await updateAdmin(adminUserDetails.id, temp);
      console.log("update admin response:", responseTemp);
      if (newPassword !== "") {
        const auth = getAuth();
        const user = auth.currentUser;
        await updatePassword(user, newPassword);
      }
      await handleGetGAAdmins();
      setEditEnabled(false);
      showNotification("Admin updated successfully.");
      // Toast("success", "admin updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating admin", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={"Admin User Details"}
        bgColor="#fff"
        buttonText={
          currentUser?.role === "super"
            ? "Edit"
            : currentUser?.role === "manager" &&
              (adminUserDetails?.role === "standard" ||
                adminUserDetails?.role === "moderator")
            ? "Edit"
            : undefined
        }
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        handleSave={() => handleUpdateAdmin()}
        loading={loading}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*Data card/container section*/}
          <AdminUserDetailsTopCardSection
            adminUserDetails={adminUserDetails}
            setAdminUserDetails={setAdminUserDetails}
            editEnabled={editEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            newPassword={newPassword}
            setNewPassword={setNewPassword}
          />
          {/*Date Added, Last Login card/container section*/}
          <AdminUserDetailsBottomCardSection
            adminUserDetails={adminUserDetails}
            setAdminUserDetails={setAdminUserDetails}
          />
        </Grid>
      </Grid>
      <ImagePreviewModal
        modalOpen={imagePreviewModal}
        handleClose={handleImagePreviewModalClose}
        image={
          uploadImage != null && uploadImage.preview
            ? uploadImage.preview
            : adminUserDetails?.photoUrl
        }
        // image={
        //   uploadImage != null && uploadImage.preview
        //     ? uploadImage.preview
        //     : images.tableDummyImage
        // }
      />
    </Box>
  );
};

export default AdminUserDetailsContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
